import axios, { AxiosRequestConfig } from 'axios'
import Cookies from 'js-cookie'
import qs from 'qs'
import { Observable } from 'rxjs'

import { APP_ACCESS_TOKEN_KEY_NAME, USER_ACCESS_TOKEN_KEY_NAME } from '../_configs/token'

import errorHandling from './error-handling'

// eslint-disable-next-line import/no-anonymous-default-export
export default function (payload: AxiosRequestConfig, isPromise = false) {
  const api = axios.create()

  payload.headers = {
    ...(payload.headers || {}),
  }

  if (payload.params) {
    payload.paramsSerializer = (params) => qs.stringify(params)
  }

  if (Cookies.get(USER_ACCESS_TOKEN_KEY_NAME)) {
    payload.headers.Authorization = `Bearer ${Cookies.get(USER_ACCESS_TOKEN_KEY_NAME)}`
  } else if (Cookies.get(APP_ACCESS_TOKEN_KEY_NAME)) {
    payload.headers.Authorization = `Bearer ${Cookies.get(APP_ACCESS_TOKEN_KEY_NAME)}`
  }

  if (isPromise) {
    return new Promise((resolve, reject) => {
      return api.request(payload)
        .then((response) => {
          resolve([response, null])
        })
        .catch((error) => {
          console.error(error)

          reject([null, errorHandling(error)])
        })
    })
  }

  return new Observable((subscriber): void => {
    api
      .request(payload)
      .then((response) => {
        subscriber.next(response)
        subscriber.complete()
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error(error)

        subscriber.error(errorHandling(error))
      })
  })
}
